import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { CommentAction as s, ReactAction as u } from "../../types.js";
import { Container as y, ActionsButtonsWrapper as C, ReplyButton as R } from "./style.js";
import { Icon as f } from "../../../../components/Icon/index.js";
import { ReactButton as b } from "../ReactButton/index.js";
import { ReactionsCounter as d } from "../ReactionsCounter/index.js";
import { useTranslation as A } from "../../../../hooks/useTranslation/index.js";
import { ReplySolid as h } from "@pelando/fontawesome/icons";
const O = ({
  dispatch: o,
  reacted: i,
  id: t,
  reactions: c,
  className: m,
  disableReply: l = !1
}) => {
  const { t: n } = A("common"), a = () => {
    o({ type: s.REPLY, payload: { id: t } });
  }, p = () => {
    o({ type: u.SHOW_REACTIONS, payload: { id: t } });
  };
  return /* @__PURE__ */ e(y, { className: m, children: [
    /* @__PURE__ */ e(C, { "data-reacted": !!i, children: [
      /* @__PURE__ */ r(b, { id: t, dispatch: o, reacted: i }),
      !l && /* @__PURE__ */ e(
        R,
        {
          onClick: a,
          title: n("comment-actions-reply-button-title"),
          children: [
            /* @__PURE__ */ r(
              f,
              {
                icon: h,
                "aria-label": n("comment-actions-reply-button-icon-aria-label")
              }
            ),
            n("comment-actions-reply-button-title")
          ]
        }
      )
    ] }),
    /* @__PURE__ */ r(
      d,
      {
        reactions: c,
        onClick: p
      }
    )
  ] });
};
export {
  O as CommentActionsWithReactions
};
